import type { FunctionComponent } from 'react';
import React, { useState, useMemo } from 'react';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';

import { TextButton } from '../input/text_button/TextButton';

import { PartnerFooterModal } from './components/PartnerFooterModal';

export interface PartnerFooterProps {
  footerText: string;
  footerModalButtonText?: string;
  footerModalTitle?: string;
  footerModalBodyText?: string;
}

/**
 * Custom partner footer component.
 */
export const PartnerFooter: FunctionComponent<PartnerFooterProps> = ({
  footerText,
  footerModalButtonText,
  footerModalTitle,
  footerModalBodyText,
}) => {
  // Check if modal is required.
  const isModalRequired = useMemo(() => footerModalButtonText && footerModalTitle && footerModalBodyText, [
    footerModalButtonText,
    footerModalTitle,
    footerModalBodyText,
  ]);

  const [openModal, setOpenModal] = useState(false);

  return (
    <>
      <Container maxWidth="md">
        <Box mt={2} className="footerText">
          <Typography variant="body2">
            {footerText}

            {isModalRequired && (
              <TextButton
                onClick={() => {
                  setOpenModal(true);
                }}
              >
                {footerModalButtonText}
              </TextButton>
            )}
          </Typography>
        </Box>
      </Container>

      {isModalRequired && (
        <PartnerFooterModal
          open={openModal}
          footerModalTitle={footerModalTitle}
          footerModalContent={footerModalBodyText}
          onClose={() => {
            setOpenModal(false);
          }}
        />
      )}
    </>
  );
};
